import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessCharging = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Ebene_1",
	xmlns: "http://www.w3.org/2000/svg",
	height: 100,
	width: 80,
	viewBox: "0 0 200 200",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M180,45V20h-10v25h-10V20h-10v25h-10v25c0,16.25,5.38,22.46,6.46,23.54l1.46,1.46h12.07v35c0,8.27-6.73,15-15,15s-15-6.73-15-15v-20.94c0-10.51-8.55-19.06-19.06-19.06h-10.94V20h-5c-26.96,0-57.62,10.74-72.77,20.84l-2.23,1.48v127.68H10v10H110v-10h-10V100h10.94c5,0,9.06,4.07,9.06,9.06v20.94c0,13.79,11.21,25,25,25s25-11.21,25-25v-35h12.07l1.46-1.46c1.08-1.08,6.46-7.29,6.46-23.54v-25h-10ZM30,170V47.75c13.72-8.31,38.25-16.48,60-17.61V170H30ZM180,70c0,8.16-1.62,12.81-2.7,15h-24.6c-1.08-2.19-2.7-6.84-2.7-15v-15h30v15Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#00488E",
		className: "cls-1",
		d: "M71.18,72.18c-.11-.06-.09-.05-.2-.1l-31.44,34.58h14.6l-4.98,28.13c.11,.06,.09,.05,.2,.1l31.44-34.58h-14.6l4.98-28.13Z"
	})]
});
export default SvgBusinessCharging;
